// src/redux/About/about.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../lib/api";

export const fetchAbout = createAsyncThunk("about/fetch", async (_, { signal, rejectWithValue }) => {
  try { const r = await api.get("about", { signal }); return r.data.data; }
  catch (e) { return rejectWithValue(e?.response?.data || e.message); }
});

const slice = createSlice({
  name: "about",
  initialState: { aboutData: null, status: "idle", error: null },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchAbout.pending, (s) => { s.status = "loading"; s.error = null; })
     .addCase(fetchAbout.fulfilled, (s, a) => { s.status = "succeeded"; s.aboutData = a.payload; })
     .addCase(fetchAbout.rejected, (s, a) => { s.status = "failed"; s.error = a.payload || a.error.message; });
  }
});

export const aboutState = (state) => state.about;
export default slice.reducer;
